class HighlightedProducts extends HTMLElement {
  constructor() {
    super();
    
    this.highlightedList = this.querySelector('.highlighted-list');
    this.getAllCards = this.querySelectorAll('div[data-highlighted-card]');
    this.getAllCardBtn = this.querySelectorAll('button[data-highlighted-card]');
    this.navigation = this.querySelectorAll('.highlighted-navigation-button');
    let currentIndex = 0;
    
    this.highlightedList.scrollTo(0, 0);    
    [...this.navigation].forEach(nav => {
      nav.addEventListener('click', () => {
       
        currentIndex = this.currentPosition(nav, currentIndex)
        this.scrollList(this.highlightedList, nav, currentIndex);
      })
    })    
    this.addToCartDrawer();
   
  }

  scrollList(highlightedList, nav, currentIndex) {
    let list = highlightedList;
    let size = list.children.length;
    let listWidth = Math.floor(list.scrollWidth);
    let cardWidth = Math.floor(listWidth / size);
    let difference = Math.floor(list.clientWidth / cardWidth) + 1;
    let direction = nav.getAttribute('data-switch-action');

    direction === 'next'
      ? list.scrollLeft = list.scrollLeft + cardWidth * 1

      : list.scrollLeft = list.scrollLeft - cardWidth * 1;

    this.visibilityNav(currentIndex, size, difference)
  }

  visibilityNav(currentIndex, size, difference) {
    let prev = this.navigation[0];
    let next = this.navigation[1]

    currentIndex === 0
      ? (prev.setAttribute('data-active', 'false'))
      : (prev.setAttribute('data-active', 'true'));

    currentIndex === size - difference
      ? (next.setAttribute('data-active', 'false'))
      : (next.setAttribute('data-active', 'true'));
  }

  currentPosition(nav, currentIndex) {
    return nav.getAttribute('data-switch-action') === 'next'
      ? ++currentIndex
      : --currentIndex
  }

  addToCartDrawer() {
    this.getAllCardBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        let id = parseInt(btn.getAttribute('data-product-id'));
        addToCartOpenDrawer(id, 1);
      })
    })
  }
}
customElements.define("highlighted-products", HighlightedProducts);